(function () {

  // ─── PART 1: Intercept fetch('/cart/add.js') to inject selling_plan ───────
  (function patchFetch() {
    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.includes('/cart/add')) {
        try {
          const opts = init || {};
          if (opts.body && typeof opts.body === 'string') {
            const body = JSON.parse(opts.body);
            if (body && Array.isArray(body.items)) {
              const selectedPlan = document.querySelector('input[name="selling_plan"]:checked');
              if (selectedPlan && selectedPlan.value !== '') {
                body.items = body.items.map(function (item) {
                  return Object.assign({}, item, { selling_plan: parseInt(selectedPlan.value, 10) });
                });
                init = Object.assign({}, opts, { body: JSON.stringify(body) });
              }
            }
          }
        } catch (e) {
          // parsing failed — leave request unchanged
        }
      }
      return _fetch.apply(this, [input, init]);
    };
  })();

  // ─── PART 2: Fix ATC button price display ────────────────────────────────
  function getSubscriptionPrice() {
    return document.querySelector(
      '.appstle_subscription_amount_wrapper .appstle_subscription_amount:not(.appstle_subscription_amount-appstle-sr-only)'
    )?.textContent?.trim();
  }

  function getOneTimePrice() {
    var mprData = document.getElementById('mpr-data');
    if (!mprData) return null;
    try {
      var data = JSON.parse(mprData.textContent);
      var variantId = parseInt(
        document.getElementById('mpr-variant-id')?.value || data.variants[0].id
      );
      var variant = data.variants.find(function (v) { return v.id === variantId; }) || data.variants[0];
      if (!variant) return null;
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'EUR') ? '€'
        : (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'GBP') ? '£' : '$';
      return currency + (variant.price / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return null; }
  }

  function correctPrice() {
    var atcPrice = document.getElementById('mpr-atc-price');
    var atcText  = document.getElementById('mpr-atc-text');
    if (!atcPrice || !atcText) return;

    var selectedRadio = document.querySelector('input[name="selling_plan"]:checked');
    if (selectedRadio && selectedRadio.value !== '') {
      var subPrice = getSubscriptionPrice();
      if (subPrice) {
        observer.disconnect();
        atcPrice.textContent = subPrice;
        observer.observe(atcText, { childList: true, subtree: true, characterData: true });
      }
    } else {
      var oneTimePrice = getOneTimePrice();
      if (oneTimePrice) {
        observer.disconnect();
        atcPrice.textContent = oneTimePrice;
        observer.observe(atcText, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  var observer = new MutationObserver(function () {
    correctPrice();
  });

  function pollForAppstle(attempts) {
    attempts = attempts || 0;
    if (attempts >= 20) return;
    var radios = document.querySelectorAll('input[name="selling_plan"]');
    if (radios.length > 0) {
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          setTimeout(correctPrice, 50);
        });
      });
      var selectEl = document.querySelector('.appstle_select');
      if (selectEl) {
        selectEl.addEventListener('change', function () {
          setTimeout(correctPrice, 150);
        });
      }
      document.addEventListener('variant:changed', function () {
        setTimeout(correctPrice, 100);
      });
      var atcText = document.getElementById('mpr-atc-text');
      if (atcText) {
        observer.observe(atcText, { childList: true, subtree: true, characterData: true });
      }
      correctPrice();
    } else {
      setTimeout(function () { pollForAppstle(attempts + 1); }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { pollForAppstle(0); });
  } else {
    pollForAppstle(0);
  }

})();